import './StatisticalCalendar.scss'
import { FormattedMessage } from 'react-intl'
import { DateFormater } from 'functions/dateTimeFormat'
import LabelLang from 'component/LabelLang/label-lang'
import MainButton from 'component/shared/mainButton/MainButton'
import useSWR from 'swr'
import { END_POINTS } from 'constants/APIConstant'
import DataNotFound from 'component/shared/DataNotFound/DataNotFound'
function StatisticalCalendar() {

  // const items = [
  //   {
  //     date: '11/7/2001',
  //     title: 'النشرة الشهرية لمتوسط أسعار أهم مواد البناء بالتجزئة',
  //     Translation: [
  //       {
  //         "title": "Monthly bulletin of the average prices of the most important building materials",
  //         "locale": "en"
  //       }
  //     ]
  //   },
  //   {
  //     date: '11/8/2001',
  //     title: 'نشرة الأرقام القياسية لأسعار المنتجين',
  //     Translation: [
  //       {
  //         "title": 'Bulletin of Producer Price Index Numbers',
  //         "locale": "en"
  //       }
  //     ]
  //   },
  //   {
  //     date: '11/9/2011',
  //     title: 'نشرة الأرقام القياسية لأسعار المنتجين',
  //     Translation: [
  //       {
  //         "title": 'Bulletin of Producer Price Index Numbers',
  //         "locale": "en"
  //       }
  //     ]
  //   },
  //   {
  //     date: '10/2/2021',
  //     title: 'نشرة الأرقام القياسية لأسعار المنتجين',
  //     Translation: [
  //       {
  //         "title": 'Bulletin of Producer Price Index Numbers',
  //         "locale": "en"
  //       }
  //     ]
  //   }/*,
  //   {
  //     date: '11/7/2008',
  //     title: 'نشرة الأرقام القياسية لأسعار المنتجين',
  //     Translation: [
  //       {
  //         "title": 'Bulletin of Producer Price Index Numbers',
  //         "locale": "en"
  //       }
  //     ]
  //   }*/
  // ]

  const CalendarData = useSWR({
    url: END_POINTS.HOME_CALENDAR,
  });
  const Calendar =
  CalendarData.error ||
  CalendarData.isLoading ||
  CalendarData.data === undefined ||
  CalendarData.data === null
        ? []
        : CalendarData.data.data;


  return (
    <div className="statisticalCalendar">
      <div className="m__title">
        <h3>
          <FormattedMessage id="statistical-calendar" />
        </h3>
      </div>
      <div className="item-calendar">
        {Object.keys(Calendar).length > 0 ?
          Calendar.map(({ date, publication } , i) => (
            <div key={i}>
              <h6>
                <DateFormater value={date} />
              </h6>
              <h4>
                <LabelLang
                  id="name"
                  defaultValue={publication.name}
                  translations={publication.publicationTranslations}
                />
              </h4>
              <hr />
            </div>
          ))
          :
          <DataNotFound />
        }
      </div>
      <div className="row-r mt-5">
        <MainButton link={"calendar"} text={"agenda"} />
      </div>
    </div>
  );
}

export default StatisticalCalendar